import { Fragment } from 'react';

export interface StepIndicatorStep {
  text: string;
}

export interface StepIndicatorProps {
  steps: StepIndicatorStep[];
}

export function StepIndicator({ steps }: StepIndicatorProps) {
  return (
    <div className="mb-[14px] flex items-center justify-center">
      {steps.map((step, index) => (
        <Fragment key={step.text}>
          <div className="flex flex-col items-center">
            {/* #0b2545: legacy StepIndicator first-step color. */}
            <span
              className={`flex size-8 shrink-0 items-center justify-center rounded-full font-sans text-[13px] font-bold text-primary-foreground ${
                index === 0
                  ? 'bg-[#0b2545] shadow-[0_0_0_3px_var(--content-blue)]'
                  : 'bg-secondary-foreground'
              }`}
            >
              {index + 1}
            </span>
            {/* 10px: legacy StepIndicator label size; no Tailwind scale match. */}
            <span className="mt-[3px] max-w-[90px] text-center font-sans text-[10px] leading-3 text-muted-foreground">
              {step.text}
            </span>
          </div>
          {index < steps.length - 1 ? (
            <span className="mx-1.5 mb-[18px] h-0.5 max-w-20 grow shrink-0 bg-[var(--content-blue-dark)]" />
          ) : null}
        </Fragment>
      ))}
    </div>
  );
}
